import { useState, useEffect, useRef } from "react";
import { ONBOARDING_STEP } from "../../constants/app.constants";
import "./image-carousel.scss";
import BackgroundImage from "../../assets/images/steps/step-background.svg";
import Lottie from "react-lottie-player";
import WelcomeAnimation from "../../assets/animations/welcome-step.animation.json";
import WhoIsUsingAnimation from "../../assets/animations/who-is-using-step.animation.json";
import TeamIntroAnimation from "../../assets/animations/team-intro.animation.json";
import UsageAnimation from "../../assets/animations/usage-step.animation.json";
export interface ImageCarouselProps {
  CurrentStep: string;
}

export const ImageCarousel = ({ CurrentStep }: ImageCarouselProps) => {
  const LottieRef = useRef(null);

  const GetAnimationAsset = () => {
    if (!LottieRef.current) return;
    setTimeout(() => {
      if (typeof (LottieRef.current! as any).play === "function") {
        (LottieRef.current! as any).play();
      }
    }, 250);
    switch (CurrentStep) {
      case ONBOARDING_STEP.WELCOME:
        if (typeof (LottieRef.current! as any).loop != null) {
          (LottieRef.current! as any).loop = false;
        }
        return WelcomeAnimation;
      case ONBOARDING_STEP.WHO_IS_USING:
        (LottieRef.current! as any).loop = true;
        return WhoIsUsingAnimation;
      case ONBOARDING_STEP.TEAM_INTRO:
        (LottieRef.current! as any).loop = true;
        return TeamIntroAnimation;
      case ONBOARDING_STEP.USAGE:
        (LottieRef.current! as any).loop = true;
        return UsageAnimation;
      case ONBOARDING_STEP.FINISH:
        return "";
    }
  };

  return (
    <div className="image-container">
      <div
        className={["image current-image"].join(" ")}
        style={{ backgroundImage: `url("${BackgroundImage}")`, userSelect: "none" }}
      ></div>
      <Lottie
        ref={LottieRef}
        loop={false}
        autoPlay
        animationData={GetAnimationAsset()}
        className={[CurrentStep === ONBOARDING_STEP.USAGE && "fade-in"].join(
          " "
        )}
        style={{
          height: "420px",
          width: "420px",
          position: "absolute",
          top: "calc(50% - 210px)",
          left: "calc(50% - 210px)",
        }}
      />
    </div>
  );
};
